import API from './axios';

// ────────────────────────────────────────────────────────
// Get all services (with optional filters)
// Usage: getServices({ category: 'plumbing', minPrice: 500 })
// ────────────────────────────────────────────────────────
export const getServices = async (filters = {}) => {
  const response = await API.get('/services', { params: filters });
  return response.data;
};

// ────────────────────────────────────────────────────────
// Get single service
// ────────────────────────────────────────────────────────
export const getService = async (id) => {
  const response = await API.get(`/services/${id}`);
  return response.data;
};

// ────────────────────────────────────────────────────────
// Create service (pro only)
// ────────────────────────────────────────────────────────
export const createService = async (data) => {
  const response = await API.post('/services', data);
  return response.data;
};

// ────────────────────────────────────────────────────────
// Update service (pro only, owner only)
// ────────────────────────────────────────────────────────
export const updateService = async (id, data) => {
  const response = await API.put(`/services/${id}`, data);
  return response.data;
};

// ────────────────────────────────────────────────────────
// Delete service (soft delete)
// ────────────────────────────────────────────────────────
export const deleteService = async (id) => {
  const response = await API.delete(`/services/${id}`);
  return response.data;
};

// ────────────────────────────────────────────────────────
// Get my services (pro only)
// ────────────────────────────────────────────────────────
export const getMyServices = async () => {
  const response = await API.get('/services/my/list');
  return response.data;
};